import { Form, Select } from 'antd';
import { FormInstance } from 'antd/es/form/hooks/useForm';
import { useMemo } from 'react';
import { useTranslation } from 'translations/hooks';

import { NumberRangeInputWithMessage } from 'ui/form/number-range-input-with-message';

import { RingRange, SetComplianceFormValues } from './types';

export const SetComplianceForm = ({
  form,
  save,
}: {
  form: FormInstance<SetComplianceFormValues>;
  save: (row: SetComplianceFormValues) => void;
}) => {
  const { t } = useTranslation();

  const selectedRange = Form.useWatch('ringRange', form);

  const ringRangeOptions = useMemo(() => {
    return Object.values(RingRange).map((range) => ({
      label: t(
        'qualityControl.recordSegmentDefect.complianceModal.rangeOptions.option',
        {
          context: range,
        },
      ),
      value: range,
    }));
  }, [t]);

  return (
    <Form<SetComplianceFormValues>
      form={form}
      layout="vertical"
      onFinish={save}
    >
      <Form.Item
        name="ringRange"
        label={t(
          'qualityControl.recordSegmentDefect.complianceModal.rangeLabel',
        )}
        layout="vertical"
        rules={[{ required: true }]}
      >
        <Select
          placeholder={t('input.segmentRange.placeholder')}
          options={ringRangeOptions}
          allowClear
        />
      </Form.Item>

      {selectedRange === RingRange.Interval ? (
        <NumberRangeInputWithMessage
          name="ringNumberRange"
          label={t('input.segmentRange.rangeLabel')}
          leftPlaceholder={t(
            'qualityControl.recordSegmentDefect.complianceModal.firstRingLabel',
          )}
          rightPlaceholder={t(
            'qualityControl.recordSegmentDefect.complianceModal.lastRingLabel',
          )}
        />
      ) : null}
    </Form>
  );
};
